import { get } from 'lodash';

import { trackRegister } from '@src/metrics';
export const COMPANY_SET = `${__dirname}/companySet`;

export function setCompany(company) {
  trackRegister({
    payload: {
      'Company Country': get(company, 'country.longName'),
      'Company Id': company.id,
      'Company Name': get(company, 'name'),
      'Feature Flags': get(company, 'featureFlags'),
    },
  });

  return {
    company: company,
    type: COMPANY_SET,
  };
}

export const UPDATE_COMPANY_PROFILE_ID = `${__dirname}/updateCompanyProfileId`;
export function updateCompanyProfileId(id) {
  return {
    id,
    type: UPDATE_COMPANY_PROFILE_ID,
  };
}

export const UPDATE_COMPANY_PROFILE = `${__dirname}/updateCompanyProfile`;
export function updateCompanyProfile(profile) {
  return {
    profile,
    type: UPDATE_COMPANY_PROFILE,
  };
}

export const UPDATE_COMPANY = `${__dirname}/updateCompany`;
export function updateCompany(company) {
  return {
    company,
    type: UPDATE_COMPANY,
  };
}
